import type { FeedbackQuestionResponse } from '@lms/api-client/backend';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@lms/ui/table';
import { Link } from 'react-router-dom';
import { useTranslations } from 'use-intl';
import { DeleteConfirmationMenu } from '@/components/delete-confirmation-menu';
import { removeQuestion } from '@/features/survey/survey-admin-api';

// Ports features/survey/components/question-list.tsx. The Next `TableListView`
// (with its built-in delete action and `router.refresh`) becomes a table using
// the shared `DeleteConfirmationMenu`; deletion revalidates via `onChanged`.
export default function QuestionList({
  questions,
  slug,
  onChanged,
}: {
  questions: FeedbackQuestionResponse[];
  slug: string;
  onChanged: () => void;
}) {
  const t = useTranslations('admin');

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t('name')}</TableHead>
          <TableHead></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {questions.map((question) => (
          <TableRow key={question.id}>
            <TableCell>
              <Link to={`/${slug}/admin/surveys/question/${question.id}`}>
                {question.description}
              </Link>
            </TableCell>
            <TableCell className="text-right">
              <DeleteConfirmationMenu
                id={question.id}
                onDelete={removeQuestion}
                onDeleted={onChanged}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
